export function staticUrl(path) {
  // Set by including javascript_assets.html in the django html template loading this app.
  if (window.config && typeof window.config.staticUrl === "function") {
    return window.config.staticUrl(path);
  }

  // For the tests, we don't set the `getStaticUrl`
  return path;
}

export function getQueryParam(key = "") {
  const param = new URLSearchParams(window.location.search).get(key);
  if (param === "false" || param === null) {
    return false;
  }
  if (param === "true" || param === "") {
    return true;
  }
  return param;
}

export function setQueryParam(key, value) {
  const params = new URLSearchParams(location.search);

  if (params.get(key) === value) {
    return;
  }

  if (value === null) {
    params.delete(key);
  } else {
    params.set(key, value);
  }

  const query = String(params).length > 0 ? `?${params}` : "";
  window.history.replaceState({}, "", `${location.pathname}${query}`);
}
